import {
  convertEmbindVectorToArray,
  PRMarinaNode,
} from '@sketch-hq/sketch-web-renderer'

/**
 * Whether the node is a Section the document gives no visual boundary to - no
 * enabled fill and no enabled border. Sections no longer carry a default style,
 * so these are invisible on the canvas and we draw a dashed overlay for them
 * instead. Adding any fill or border makes the Section paint itself again and
 * the overlay steps aside.
 *
 * Shadows and blurs aren't considered: with no fill or border to cast from,
 * they paint nothing, so a Section carrying only those is still invisible.
 */
export const isUnstyledSection = (node: PRMarinaNode | null): boolean => {
  if (!node?.isSection()) {
    return false
  }

  const style = node.getLayer()?.getStyle()?.getLayerStyle()

  if (!style) {
    return true
  }

  const hasFill = convertEmbindVectorToArray(style.fills).some(
    fill => fill.isEnabled
  )
  const hasBorder = convertEmbindVectorToArray(style.borders).some(
    border => border.isEnabled
  )

  return !hasFill && !hasBorder
}
